import CalendarItem from 'owa-service/lib/contract/CalendarItem';
import TimeConstants from 'mini-datetime-utils/lib/dateValues/TimeConstants';
import { CalendarEvent } from 'mini-calendar-event-types';
import { calendarEvent } from 'mini-calendar-event-converter';
import { getTimestamp, startOfDay } from 'owa-datetime';
import { isEventInPeoplesCalendar } from 'mini-event-to-calendar-association/lib/api/isEventInPeoplesCalendar';
import { MailboxInfo } from 'owa-client-ids';

/**
 * Utility which generates a calendar event from a calendar item by enriching it with addition of the necessary params
 * @param item
 * @param mailboxInfo
 */
export const calendarEventWithPeoplesCalendarInfo = (
    item: CalendarItem,
    mailboxInfo: MailboxInfo
): CalendarEvent => {
    const originalCalendarEvent: CalendarEvent = calendarEvent(item, mailboxInfo);
    const { Start, IsAllDayEvent: IsOriginallyAllDayEvent } = originalCalendarEvent;

    // All day event info also depends on whether the event belongs to people calendar or not
    const isAllDayQualifier: boolean =
        isEventInPeoplesCalendar(originalCalendarEvent) &&
        originalCalendarEvent.durationInMs() === TimeConstants.MillisecondsInOneDay &&
        getTimestamp(Start) === getTimestamp(startOfDay(Start));

    const IsAllDayEvent: boolean = IsOriginallyAllDayEvent || isAllDayQualifier;

    return calendarEvent({ ...item, IsAllDayEvent }, mailboxInfo);
};
